import { render } from "./mashairi.vue?vue&type=template&id=71c6b020"
import script from "./mashairi.vue?vue&type=script&lang=js"
export * from "./mashairi.vue?vue&type=script&lang=js"
script.render = render

export default script